<template>
  <div>
    <v-card
        class="mb-5"
    >

        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $t(`enrollments.doc_uploaded`) }}</span>
                </v-card-title>

                <v-card-text>
                    <object :data="path_file" width="460px" height="500px"></object>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="dialog = false">{{ $t(`enrollments.cancel`) }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-data-table
            :headers="headers"
            :items="documents"
            :loading="loadingTable"
            class="elevation-1"
        >
            <template slot="items" slot-scope="props">
                <td class="text-xs-center">{{ props.item.document.description }}</td>
                <td class="text-xs-center">{{ props.item.document.ext }}</td>
                <td>
                    <v-icon
                        small
                        class="mr-2"
                        @click="showFile(props.item.id)"
                    >
                        remove_red_eye
                    </v-icon>
                </td>
            </template>
        </v-data-table>
        <v-layout row justify-center mt-3>
          <v-btn flat @click="goToPrevStep">{{ $t(`enrollments.back`) }}</v-btn>
          <v-btn
              color="primary"
              @click="goToNextStep"
          >
          {{ $t(`enrollments.next`) }}
          </v-btn>
        </v-layout>
    </v-card>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    name: 'enrollment-step-3',
    components: {
    },
    data() {
      return {
        dialog: false,
        headers: [
            { text: this.$t(`enrollments.header.document`), align: 'center', sortable: false},
            { text: this.$t(`enrollments.header.extension`), align: 'center', sortable: false },
            { text: this.$t(`enrollments.header.actions`), align: 'center', sortable: false }
        ],
        documents: [],
        loadingTable: false,
        path_file: '',
        vistaUrl: window.config.vistaUrl,
      }
    },
    created () {
      this.init();
    },
    computed: {
      ...mapGetters({
        enrollment_id: 'currentEnrollmentId',
        enrollment_status: 'currentEnrollment',
        student: 'currentEnrollmentStudent',
      }),
    },
    watch: {
      enrollment_status(newValue, oldValue) {
        if (newValue.documents) {
          this.documents = newValue.documents.filter(document => {
            if(document.document) {
              return true
            }
            return false
          })
        }
      }
    },
    methods: {
      init() {
        if (this.enrollment_status.documents) {
          this.documents = this.enrollment_status.documents.filter(document => {
            if(document.document) {
              return true
            }
            return false
          })
        }
      },
      showFile(id) {
        const fileToShow = this.documents.find(document => document.id === id)
        if (fileToShow[`360_document_status`]) {
          const id_doc = fileToShow['360_document_id']
          const url = `${this.vistaUrl}ViewDocument?id=${id_doc}`
          this.path_file = url
          this.dialog = true
          return
        }
        this.path_file = fileToShow.path_file
        this.dialog = true
      },
      goToPrevStep() {
        this.$emit('goToPrevStep', 2)
      },
      goToNextStep() {
        this.$emit('goToNextStep', 4)
      },
    },
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/enrollment/enrollment_step3.vue